// src/pages/staff/StaffSkeleton.jsx
import React from "react";

const SkeletonRow = () => (
  <tr>
    {[1, 2, 3, 4, 5, 6].map((i) => (
      <td key={i}>
        <div className="skeleton skeleton-cell" />
      </td>
    ))}
  </tr>
);

export default function StaffSkeleton() {
  return (
    <>
      {/* کارت فرم افزودن (اگر صفحه لیست فرم افزودن داشته باشد) */}
      <div className="card">
        <div className="skeleton skeleton-title" />
        <div className="grid">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="skeleton-field">
              <div className="skeleton skeleton-label" />
              <div className="skeleton skeleton-input" />
            </div>
          ))}
        </div>
        <div className="flexend">
          <div className="skeleton skeleton-btn" />
        </div>
      </div>

      {/* کارت لیست */}
      <div className="card">
        <div className="skeleton skeleton-title" />
        <div className="overflow">
          <table>
            <thead>
              <tr>
                <th>نام</th>
                <th>شماره تماس</th>
                <th>نقش</th>
                <th>وضعیت</th>
                <th>دسترسی‌ها</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5].map((i) => (
                <SkeletonRow key={i} />
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <style>{`
        .skeleton {
          background: linear-gradient(
            90deg,
            var(--border) 25%,
            var(--border-strong) 50%,
            var(--border) 75%
          );
          background-size: 200% 100%;
          animation: skeleton-shimmer 1.4s ease-in-out infinite;
          border-radius: 8px;
        }
        @keyframes skeleton-shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        .skeleton-title {
          height: 22px;
          width: 40%;
          margin-bottom: 20px;
        }
        .skeleton-field {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .skeleton-label {
          height: 13px;
          width: 40%;
        }
        .skeleton-input {
          height: 42px;
          width: 100%;
          border-radius: 10px;
        }
        .skeleton-btn {
          height: 44px;
          width: 180px;
          border-radius: 12px;
        }
        .skeleton-cell {
          height: 18px;
          width: 80%;
          margin: 0 auto;
        }
      `}</style>
    </>
  );
}